export default {
  constReason: [
    { id: 1, value: "Người mua không nhận được sản phẩm" },
    { id: 2, value: "Người mua yêu cầu trả sản phẩm" },
    { id: 3, value: "Giao dịch lỗi" },
    { id: 4, value: "Giao dịch gian lận, giả mạo" },
    { id: 5, value: "Lý do khác" },
  ],
  transactions: [],

  //Tên drop
  nameStore: "Tất cả",
  nameType: "Tất cả",

  // Biến tính tổng
  totalAmount: null,
  totalFeeAmount: null,
  totalOrderAmount: null,

  //Biến ẩn hiện
  isShowItemTypeService: false,
  isShowTypePayment: false,
  isShowStore: false,
  isShowExtend: false,
  isShowPopUpRefund: false,
  isShowItemStatus: false,
  // Đối tượng status
  statusRefunds: [
    { id: -1, name: "Tất cả" },
    { id: 0, name: "Chờ hoàn tiền" },
    { id: 1, name: "Đã hoàn tiền" },
    { id: 2, name: "Hoàn tiền thất bại" },
  ],
  // đối tượng loại dịch vụ
  typeService: [
    { id: -1, name: "Tất cả" },
    { id: 0, name: "Cổng thanh toán" },
    { id: 1, name: "Thu hộ" },
  ],
  // đối tượng hình thức thanh toán
  typePayment: [
    { id: "", name: "Tất cả" },
    { id: 0, name: "Thẻ nội địa" },
    { id: 1, name: "VISA" },
    { id: 2, name: "MASTER CARD" },
  ],
  // đối tượng chi nhánh
  store: [
    { id: "", name: "Tất cả" },
    { id: 0, name: "Cửa hàng 1" },
    { id: 1, name: "Cửa hàng 2" },
    { id: 2, name: "Cửa hàng 3" },
  ],

  //Đối tượng truyền vào filter
  filters: {
    serviceCode: "",
    orderId: "",
    merchantCode: "",
    cardNumber: "",
    paymentType: "",
    branch: "",
    status: "",
  },

  // đối tượng phân trang
  paginations: {
    start: 0,
    end: null,
    page: 0,
    maxVisiblePages: 2,
    totalItems: 0,
    loading: false,
    itemsPerPage: 20,
  },
};
